<template>
  <div class="app-activation-success-wrapper">
    <ShowSuccessIdentLinks>
      <template v-for="slot in possibleChildSlotsFor('SuccessSelect')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowSuccessIdentLinks>
    <ShowTariffInfoBox :tariff="selectedTariff">
      <template v-for="slot in possibleChildSlotsFor('TariffInfoBox')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowTariffInfoBox>
    <div class="personal-data-content">
      <div class="before-personal-data"><slot name="txtBeforePersonalDataContent"></slot></div>
      <ShowSuccessPersonalData>
        <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowSuccessPersonalData>
      <ShowSuccessIdentData>
        <template v-for="slot in possibleChildSlotsFor('IdentSummary')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowSuccessIdentData>
    </div>
    <div class="payment-content">
      <ShowPaymentData :payment="_payment" v-if="hasTopUp">
        <template v-for="slot in possibleChildSlotsFor('Payment')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowPaymentData>
      <div class="payment-without-topup"  v-if="withoutTopUp">
        <slot name="txtPaymentWithoutTopup"></slot>
      </div>
      <ShowTopUpData>
        <template v-for="slot in possibleChildSlotsFor('TopUp')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowTopUpData>
    </div>
  </div>
</template>

<script>
import ShowSuccessIdentLinks from '@/components/process/LIDL/Activation/Success/ShowSuccessIdentLinks.vue'
import { stepName as previousStep } from '@/components/process/LIDL/Activation/Summary/ActivationSummary.vue'
import processSteps from '@/mixins/processSteps'
import ShowSuccessPersonalData from '@/components/process/LIDL/Activation/PersonalData/ShowSuccessPersonalData.vue'
import ShowSuccessIdentData from '@/components/process/LIDL/Activation/PersonalData/ShowSuccessIdentData.vue'
import ShowPaymentData from '@/components/process/LIDL/Activation/Payment/ShowPaymentData.vue'
import ShowTopUpData from '@/components/process/LIDL/Activation/TopUp/ShowTopUpData.vue'
import { mapGetters } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import ShowTariffInfoBox from '@/components/process/LIDL/Activation/Tariff/ShowTariffInfoBox.vue'

export const stepName = 'success'

export default {
  name: 'ActivationSuccess',
  components: {
    ShowTariffInfoBox,
    ShowSuccessIdentLinks,
    ShowSuccessPersonalData,
    ShowSuccessIdentData,
    ShowPaymentData,
    ShowTopUpData
  },
  mixins: [
    processSteps(stepName, previousStep, stepName),
    slotProxy()
  ],
  computed: {
    _payment: function () {
      return {
        ...this.payment,
        type: this.payment.paymentType
      }
    },
    disabledNext: function () {
      return !this.consent.agb || !this.consent.informationArticle
    },
    ...mapGetters('activation/payment', [
      'payment'
    ]),
    ...mapGetters('activation/topUp', [
      'hasTopUp', 'withoutTopUp'
    ]),
    selectedTariff: function () {
      return this.savedTariff || {}
    },
    ...mapGetters('activation/tariff', [
      'savedTariff'
    ])
  }
}
</script>
